import { render } from "./MaterialTextarea.vue?vue&type=template&id=5708af46"
import script from "./MaterialTextarea.vue?vue&type=script&lang=js"
export * from "./MaterialTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__